<template>
  <div>
    <div :class="['dropdown_select_container', !isEditable ? 'view_only' : '']">
      <v-select v-if="isEditable" style="min-width:265px" v-model="orderMetadata.financeUserId" @input="viewModal"
        :reduce="(user) => user.id" label="name" :options="filteredUsers" placeholder="Choose..." :disabled="$route.params.id <= 0 ||
          isReadOnly ||
          !(isLogistics || isFinance || isSponsor) ||
          isCompletedOrder || !isEditable
          ">
        <template v-slot:option="option">
          {{ option.nameLabel }}

        </template>
      </v-select>
      <p class="dropdown_text_wrap" v-else> <i v-if="selectedUserLabel.isLocked" class="tim-icons icon-lock-circle"
          aria-hidden="true"></i>
        {{ selectedUserLabel.label }}</p>

      <el-button style="margin-left:2px" size="mini" v-if="
        ($route.params.id != 0 ||
        (isLogistics || isFinance || isSponsor) ||
        !isReadOnly ||
        !isCompletedOrder) && !isPartnerAccount
      " :class="isEditable ? 'editing' : 'btn-secondary'" v-show="!isReadOnly"
        :icon="isEditable ? 'el-icon-close' : 'el-icon-edit'" @click="toggleEdit()"
         :disabled="$route.params.id <= 0"
        ></el-button>
    </div>
    <!-- small modal -->
    <modal :show.sync="modals.notice" headerClasses="justify-content-center" type="notice">
      <h4 slot="header" class="title title-up">CHANGE FINANCE USER</h4>
      <hr />
      <div class="container">
        <div class="form-group">
          <base-checkbox v-model="sendAssignerCopy">Send Me a Copy</base-checkbox>
        </div>
        <div class="row">
          <div class="col-md-12">
            <base-input label="Note">
              <textarea class="form-control" placeholder="Add a brief description" rows="5" v-model="note"></textarea>
            </base-input>
          </div>
        </div>
      </div>
      <template slot="footer">
        <div class="container alert_footer">
          <base-button style="margin-right: 2px" type="danger" class="alert_footer_button btn_extra_small btn_info" @click.native="cancel">
            Close
          </base-button>
          <base-button type="primary" class="alert_footer_button btn_extra_small btn_info" @click.native="confirm">
            Confirm
          </base-button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Modal, BaseButton, BaseCheckbox } from "@/components";
import { EventBus } from "@/event-bus.js";
import {
  Button,
} from "element-ui";
export default {
  name: "finance-user-select",
  // this orderIdProp is used to edit transaction in a modal method, it will be passed in from the transaction Index page
  // if we go this way. it can be removed if we don't use the modal method
  props: ["isFinanceUser", "isLogisticsUser", "isReadOnly", "orderIdProp"],
  data() {
    return {
      modals: {
        notice: false,
      },
      sendAssignerCopy: false,
      note: null,
      selectedUserId: null,
      isEditable: false
    };
  },
  components: {
    Modal,
    BaseButton,
    BaseCheckbox,
    EventBus,
    [Button.name]: Button,
  },
  computed: {
    ...mapGetters({
      financeUsers: "users/financeUsers",
      orderMetadata: "orderMetadata/orderMetadata",
      financeUserId: "orderMetadata/financeUserId",
      isLogistics: "authentication/isLogistics",
      isFinance: "authentication/isFinance",
      isPartnerAccount: "authentication/isPartnerAccount",
      isSponsor: "authentication/isSponsor"
    }),
    isCompletedOrder() {
      return this.orderMetadata.orderStatus == "COMPLETED";
    },
    selectedUserLabel() {
      let selectedUser;
      if (this.selectedUserId) {
        selectedUser = this.financeUsers.find(user => user.id === this.selectedUserId);
      } else {
        selectedUser = this.financeUsers.find(user => user.id === this.financeUserId);
      }
      return selectedUser ? { label: selectedUser.nameLabel, isLocked: selectedUser.lockedBy ? true : false } : { label: 'No Finance user selected' };
    },
    filteredUsers() {
      let selectedUser = this.financeUsers.filter((e) => e.id == this.selectedUserId)
      if (selectedUser.length && selectedUser[0].lockedBy) {
        return [...selectedUser, ...this.financeUsers.filter((e) => e.lockedBy == null || undefined)]
      } else {
        return this.financeUsers.filter((e) => e.lockedBy == null || undefined)
      }

    }
  },
  async mounted() {
    // either use prop order id or the param order id
    let id = this.orderIdProp == undefined ? this.$route.params.id : this.orderIdProp;
    await this.getOrderMetadata(id);
    this.selectedUserId = this.orderMetadata.financeUserId
  },
  methods: {
    ...mapActions({
      onFinanceChange: "orderMetadata/onFinanceChange",
      getOrderMetadata: "orderMetadata/getOrderMetadata",
    }),
    async cancel(e) {
      let ctx = this;
      let id = this.orderIdProp == undefined ? this.$route.params.id : this.orderIdProp;
      await ctx.getOrderMetadata(id);
      ctx.modals.notice = false;
      this.selectedUserId = this.orderMetadata.financeUserId
    },
    viewModal(e) {
      if (e) {
        this.selectedUserId = e;
        this.modals.notice = true;
      }
    },
    async toggleEdit() {
      if (this.isEditable) {
        await this.cancel();
        this.orderMetadata.financeUserId = this.selectedUserId
        this.isEditable = false
      } else {
        this.isEditable = true
      }
    },

    async confirm(e) {
      let ctx = this;
      let id = this.orderIdProp == undefined ? this.$route.params.id : this.orderIdProp;
      try {
        this.$loaderApp.addRequest();

        if (this.selectedUserId == null) {
          ctx.$toast.error("Please select a user!");
          ctx.modals.notice = false;
          this.$loaderApp.completeRequest();
          this.isEditable = false
          return;
        }
        await ctx.onFinanceChange({
          orderId: id,
          sendAssignerCopy: ctx.sendAssignerCopy,
          note: ctx.note,
          selectedUserId: ctx.selectedUserId,
        });
        ctx.modals.notice = false;
        EventBus.$emit('finance-user-change', id);
        this.$loaderApp.completeRequest();
        this.isEditable = false

      } catch (error) {
        ctx.$toast.error("Error Occurred! Please try again later.");
        this.$loaderApp.completeRequest();
        this.isEditable = false

      }
    },
  },
};
</script>
<style>
.el-button.editing {
  color: #fff;
  border-color: red;
  background-color: red;
}
</style>